import {
  EVENT_PANEL_LANG_SYNC,
  LS_AGENT_PANEL_LANG,
  LS_USER_PANEL_LANG,
  normalizePanelLanguageLabel,
} from '@/lib/panel-i18n/constants';

export function emitPanelLanguageSync(zone, lang) {
  if (typeof window === 'undefined') return;
  const z = zone === 'agent' ? 'agent' : 'user';
  const key = z === 'agent' ? LS_AGENT_PANEL_LANG : LS_USER_PANEL_LANG;
  const normalized = normalizePanelLanguageLabel(lang);
  const prev = window.localStorage.getItem(key);
  if (prev === normalized) return;
  window.localStorage.setItem(key, normalized);
  window.dispatchEvent(
    new CustomEvent(EVENT_PANEL_LANG_SYNC, { detail: { zone: z, lang: normalized } })
  );
}
